import React from 'react'
import { Box, Stack, Typography } from '@mui/material';

const ExerciseVideos = ({exerciseVideos, name}) => {
  return (
    <Box sx={{ marginTop: { lg: '200px', xs: '20px' }}} p="20px" >
      <Typography variant='h4' mb="33px">
        Watch <span style={{color: '#ff2625', textTransform: 'capitalize'}}>{name}</span> exercise videos
      </Typography>
      <Stack justifyContent="center" flexWrap="wrap" alignItems="center"
        sx={{
          flexDirection: { lg: 'row' },
          gap: { lg: '107px', xs: '50px' }
        }}
      >
        {exerciseVideos?.slice(0, 6).map((item, index) => (
          <a
            key={index}
            className='exercise-video'
            href={`https://www.youtube.com/watch?v=${item.video.videoId}`}
            target="_blank"
            rel="noreferrer"
          >
            <img src={item.video.thumbnails[0].url} className="vid-thumbnail" alt={item.video.title} />
            <Box>
              <Typography variant="h5" mb="5px" align="center" color="#000">
                {item.video.title}
              </Typography>
              <Typography variant="h6" align="center" color="#212121">
                {item.video.channelName}
              </Typography>
            </Box>
          </a>
        ))}
      </Stack>
    </Box>
  )
}

export default ExerciseVideos